const customHeader = `
  <div class="custom-header">
    <a class="custom-header__item about" href="/o-nas" title="O nás"">
      <img src="/user/documents/img/ico-flag-black.svg" title="O nás" />
      <span>O nás</span>
    </a>
    <a class="custom-header__item bikes" href="/kola-na-zakazku" title="Kola na zakázku">
      <img src="/user/documents/img/ico-bike-black.svg" title="Kola na zakázku" />
      <span>Kola na zakázku</span>
    </a>
    <a class="custom-header__item servis" href="/servis" title="Servis">
      <img src="/user/documents/img/ico-wrench-plus-black.svg" title="Servis" />
      <span>Servis</span>
    </a>
    <a class="custom-header__item test" href="/test-centrum" title="Test centrum">
      <img src="/user/documents/img/ico-test-centrum-black.svg" title="Test centrum" />
      <span>Test centrum</span>
    </a>
    <a class="custom-header__item" href="https://team.futurecycling.cz" title="MTB Team" target="_blank">
      <img src="/user/documents/img/ico-people-black.svg" title="MTB Team" />
      <span>MTB Team</span>
    </a>
    <a class="custom-header__item custom-header__item--last-item contact" href="/kontakt" title="Kontakt">
      <img src="/user/documents/img/ico-mail-magnifying-black.svg" title="Kontakt" />
      <span>Kontakt</span>
    </a>
    <a class="custom-header__item custom-header__item--phone custom-header__item--resp" href="tel:+420252546399" title="Telefon">
      <img src="/user/documents/img/ico-phone-black.svg" title="Telefon" />
      <span>Kontakt</span>
    </a>
    <a class="custom-header__item custom-header__item--email custom-header__item--resp" href="mailto:obchod@futurecycling.cz" title="E-mail">
      <img src="/user/documents/img/ico-mail-magnifying-black.svg" title="E-mail" />
      <span>E-mail</span>
    </a>
  </div>
`;

export {
  customHeader
};